import * as React from 'react';

import { Filter } from '../../../regions/components/Filter';
import { PeriodContainer } from '../../../regions/containers/PeriodContainer';
import { RatingListContainer } from '../../../regions/containers/RatingListContainer';
import { RealtyTypeContainer } from '../../../regions/containers/RealtyTypeContainer';
import { PromoBanner } from '../../../regions/components/PromoBanner';
import { NoSsr } from '@cian/react-utils';
import { GeoSwitcherWrapperContainer } from '../../../common/containers/GeoSwitcherContainer';
import { useDeviceType } from '@cian/ui-kit';

import { CommonContextProvidersWrapper } from '../../../common/containers/CommonContextProvideWrapper/CommonContextProviderWrapper';
import { IApplicationCommonRootComponentProps } from '../../../common/types/applicationRootComponent';
import { IApplicationContext } from '../../../common/types/applicationContext';
import { IReduxStore } from '../../../common/types/redux';
import { RegionSelectContainer } from '../../../common/containers/RegionSelectContainer';
import { FAQ } from '../../components/FAQ';
import { SubscribeEmailContainer } from '../SubscribeEmailContainer';
import { Footer } from '../../components/Footer';
import { IntroContainer } from '../IntroContainer';
import { SharingSocialContainer } from '../SharingSocialContainer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: IReduxStore;
}

export const RegionsApp: React.FC<IApplicationCommonRootComponentProps> = props => {
  const device = useDeviceType();

  return (
    <CommonContextProvidersWrapper {...props}>
      {device === 'desktop' ? <GeoSwitcherWrapperContainer /> : <RegionSelectContainer />}
      <IntroContainer />
      <Filter filterRealtyType={<RealtyTypeContainer />} filterPeriod={<PeriodContainer />} />
      <RatingListContainer />
      <NoSsr>
        <SharingSocialContainer />
      </NoSsr>
      <PromoBanner />
      <FAQ />
      <SubscribeEmailContainer />
      <Footer />
    </CommonContextProvidersWrapper>
  );
};
